import { Action } from "redux";

export const GET_SUBSCRIPTION_LIST_FOR_USER =
  "SUBSCRIPTION:GET_SUBSCRIPTION_LIST_FOR_USER";

export interface GetSubscriptionListForUser extends Action {
  type: typeof GET_SUBSCRIPTION_LIST_FOR_USER;
  organizationKeyName: string;
  userId: number;
}

export const getSubscriptionListForUser = (
  organizationKeyName: string,
  userId: number
): GetSubscriptionListForUser => ({
  type: GET_SUBSCRIPTION_LIST_FOR_USER,
  organizationKeyName,
  userId,
});
